import React, { memo, useEffect } from "react";
import useFetchFooter from "hooks/useFooter/useFetchFooter";
import { API_FETCH_STATUS } from "constants/common";
import { faFooterNavClick } from "./services/ABfooter.analytics";
import LineLoader from "components/lineLoader/lineLoader";
import ErrorCard from "components/errorCard/errorCard.component";
import styles from "./ABfooter.scss";
import TopFooterComponent from "./TopFooter/TopFooter";
const { SUCCESS, ERROR, LOADING } = API_FETCH_STATUS;
const { ab_footer, container, bottom_links, footer_links, footer_bottom, copyright } = styles;

export default function ABfooter({ flowName = "" }) {
  const { fetchFooter, status, content } = useFetchFooter();

  useEffect(() => {
    fetchFooter();
  }, []);

  const footerAnalytics = ({ segment, lob, product }) => {
    faFooterNavClick({ flowName, segment, lob, product });
  };

  if (status == ERROR) return <ErrorCard />;
  if (status == LOADING) return <LineLoader show={true} />;

  const { topFooter, footerLoginSupport, socialItems, bottomFooter } = content;

  return (
    <footer className={ab_footer}>
      <TopFooterComponent
        topFooter={topFooter}
        footerLoginSupport={footerLoginSupport}
        socialItems={socialItems}
        footerAnalytics={footerAnalytics}
      />

      <div className={bottom_links}>
        <div className={container}>
          <div className={footer_bottom}>
            <div className={footer_links}>
              <ul>
                <BottomLinks bottomFooterItems={bottomFooter} footerAnalytics={footerAnalytics} />
              </ul>
            </div>

            <div className={copyright}>{new Date().getFullYear()} Airtel India. All rights reserved.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

const BottomLinks = memo(({ bottomFooterItems, footerAnalytics }) =>
  bottomFooterItems.map((bottomFooter) => (
    <li>
      <a href={bottomFooter.url} target="_blank" onClick={() => footerAnalytics({ segment: bottomFooter.linkText })}>
        {bottomFooter.linkText}
      </a>
    </li>
  )),
);
